import "./print.css"
import { useLines } from "../../utils"

const SingleOrder = ({ order, category }) => {
  const frescoLines = useLines(order, ["fresco"])
  const gastroLines = useLines(order, ["gastro", "mostarde"])

  const hasLines =
    category === "fresco" ? frescoLines.length > 0 : gastroLines.length > 0

  return hasLines ? (
    <div
      id="printTarget"
      className={category === "fresco" ? "printFresco" : "printGastro"}
    >
      <h1>{order.orderId}</h1>
      <h2>{order.name}</h2>
      <h2>{order.surname}</h2>
      <div id="contactInfo">
        <p>
          <strong>TELEFONO:</strong>
          <span>{order.phone}</span>
        </p>
        <p>
          <strong>COMUNE:</strong>
          <span>{order.cityName}</span>
        </p>
        <p>
          <strong>INDIRIZZO:</strong>
          <span>{order.address}</span>
        </p>
      </div>

      {frescoLines.length > 0 && <strong id="hasOtherFresco">+ FRESCO</strong>}
      {gastroLines.length > 0 && <strong id="hasOtherGastro">+ GASTRO</strong>}

      <div id="frescoLines">
        {frescoLines.map((line) => (
          <p key={line.id}>
            <span>
              <strong>{line.qty}&nbsp;x&nbsp;</strong>
              {line.name}
            </span>
            <span>{line.price}&nbsp;€</span>
          </p>
        ))}
      </div>

      <div id="gastroLines">
        {gastroLines.map((line) => (
          <p key={line.id}>
            <span>
              <strong>{line.qty}&nbsp;x&nbsp;</strong>
              {line.name}
            </span>
            <span>{line.price}&nbsp;€</span>
          </p>
        ))}
        <p>
          <strong>Totale</strong>
          <span>
            {gastroLines.reduce(
              (total, line) =>
                total + parseFloat(line.price) * parseFloat(line.qty),
              0.0
            )}
            &nbsp;€
          </span>
        </p>
      </div>
    </div>
  ) : null
}

const Printer = ({ orders, category }) =>
  orders.map((order) => <SingleOrder order={order} category={category} />)

export default Printer
